import React from "react";
import PortfolioHero from "../components/PortfolioHero";
import PortfolioData from "../components/PortfolioData";
import HowWeHelp from "../components/HowWeHelp";

const PortfolioPage = () => {
    return (
        <div>
            <PortfolioHero />
            <PortfolioData />
            <HowWeHelp />
        </div>
    );
};

export default PortfolioPage;
